const TitleNavbar = (props) => {
  const {record,mode,field} = props
  return (
    <span>
      {`${mode} ${record[field]}`}
    </span>
  )
}

export {TitleNavbar}